import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const FETCH_BASIS_REPORT_REQUEST = NS + 'FETCH_BASIS_REPORT_REQUEST'
export const FETCH_BASIS_REPORT_SUCCESS = NS + 'FETCH_BASIS_REPORT_SUCCESS'
export const FETCH_BASIS_REPORT_ERROR = NS + 'FETCH_BASIS_REPORT_ERROR'



// WEBPACK FOOTER //
// ./src/modules/analytics/state/basis/type.js